import Context from "shared/util/Context";
import Analytics from "./util/Analytics";
import isApp from "shared/util/isApp";
import { isMobile } from "shared/util/EnvironmentHelpers";
import { sourceFromCF } from "analytics/util/source";

import {
	GET_USER_INFO_SUCCESS,
	SET_ACTIVE_FILTER,
	GET_QUESTIONS_SUCCESS,
	SKIP_NEXT_QUESTION_SUCCESS,
} from "ducks/profile_questions";

import { USER_TYPES } from "apps/profile_questions/util/constants";
import { getUserFromUrlString } from "apps/profile_questions/util/helpers";
import { sendQuestionAnswerEvent } from "analytics/questions";

let sentPagviewEvent = false;

export default function reducer(state, action) {
	switch (action.type) {
		case GET_USER_INFO_SUCCESS: {
			// send the pageview event after we've gotten target user information (so
			// we know if it's selfview, and have the userid guaranteed present)
			if (
				sentPagviewEvent ||
				action.payload.userType !== USER_TYPES.TARGET
			) {
				return;
			}

			const isSelfview = action.payload.userInfo.userid === Context.get("userid");
			const isQuestionsPage = window.location.pathname.indexOf("/questions") >= 0;

			// the apps are handling this natively for public view
			if ((isApp() && !isSelfview) || (isMobile && !isQuestionsPage)) {
				return;
			}

			let source = sourceFromCF();

			if (isApp() || isMobile) {
				source = "profile questions section";
			}

			let eventName = Analytics.eventNames.profileViewedQuestions;

			const data = {
				source,
			};

			if (isSelfview) {
				eventName = Analytics.eventNames.profileViewedSelfviewQuestions;
			} else {
				data["target user id"] = action.payload.userInfo.userid;
			}

			Analytics.logUIEvent(eventName, { data });

			sentPagviewEvent = true;

			return;
		}

		case SET_ACTIVE_FILTER: {
			let filter = {};
			let targetUserid;

			if (state.filters) {
				filter = state.filters.find((item) => item.filter_id === action.payload.filter);
			}

			if (state[USER_TYPES.TARGET].userid) {
				targetUserid = state[USER_TYPES.TARGET].userid;
			} else if (state.isSelfView) {
				targetUserid = Context.get("userid");
			} else {
				targetUserid = getUserFromUrlString(window.location.pathname);
			}

			if (!targetUserid || !filter) {
				return;
			}

			Analytics.logUIEvent(
				Analytics.eventNames.profileSelectedQuestionsFilter,
				{
					data: {
						"filter name": filter.title,
						"filter id": filter.filter_id,
						"questions count": filter.count,
						"target user id": targetUserid,
					},
				},
			);

			return;
		}

		case GET_QUESTIONS_SUCCESS: {
			let filter = {};
			let targetUserid;

			if (state.filters) {
				filter = state.filters.find((item) => item.filter_id === state.activeFilter);
			}

			if (state[USER_TYPES.TARGET].userid) {
				targetUserid = state[USER_TYPES.TARGET].userid;
			}

			if (!state.paging || !state.paging.cursors || !filter || !targetUserid) {
				return;
			}

			Analytics.logUIEvent(
				Analytics.eventNames.profilePaginatedQuestions,
				{
					data: {
						"filter name": filter.title,
						"filter id": filter.filter_id,
						"target user id": targetUserid,
					},
				},
			);

			return;
		}

		case SKIP_NEXT_QUESTION_SUCCESS: {
			sendQuestionAnswerEvent(state.nextQuestion, {
				isSkip: true,
			});

			return;
		}

		default: {
			return;
		}
	}
}



// WEBPACK FOOTER //
// ./src/analytics/profile_questions.js